import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Row, Form, Button, Input, FormFeedback } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import "./AccountDeleteRequest.css";
import logoLight from "../../../assets/images/logo-light.png";
import { sendDeleteAccountRequest } from "../../../store/policies/actions";

const AccountDeleteRequestPage = () => {
  let { lang } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [contact] = useState([]);

  document.title = `${t("Common.Contact Us")} | ${t(
    process.env.REACT_APP_HEADING
  )}`;

  /**
   * Formik handling
   */
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: contact.password || "",
      email: contact.name || "",
      mobile: contact.mobile || "",
      reason: contact.reason || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(t("Validations.Name.Required")),
      email: Yup.string().email("Validations.Email.Invalid").nullable(),
      mobile: Yup.string()
        .required(t("Validations.Mobile.Required"))
        .min(8, t("Validations.Common.Min", { length: 8 }))
        .max(10, t("Validations.Common.Max", { length: 10 })),
      reason: Yup.string().required(t("Validations.Reason.Required")),
    }),

    onSubmit: (values) => {
      dispatch(sendDeleteAccountRequest(values));
      setTimeout(() => {
        alert(t("Common.Request Submitted Successfully"));
      }, 1000);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
  });

  return (
    <React.Fragment>
      <div className="container-fluid mt-3" dir={lang === "ar" ? "rtl" : "ltr"}>
        <Row>
          <Col lg={12}>
            <div className="text-center mt-sm-5 text-white-50">
              <div>
                <Link to="/" className="d-inline-block auth-logo">
                  <img src={logoLight} alt="" height="125" />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <section className="ftco-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="wrapper">
                  <div className="row no-gutters">
                    <div className="col-lg-7 col-md-7 order-md-last d-flex align-items-stretch">
                      <div className="contact-wrap w-100 p-md-5 p-4">
                        <h3 className="mb-4 text-danger">
                          {t("Common.Account Delete Request")}
                        </h3>
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                          className="contactForm"
                        >
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <div className="form-group">
                                <label className="label" htmlFor="name">
                                  {t("Fields.Full Name")}
                                  <span className="text-danger">*</span>
                                </label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  placeholder={t("Fields.Name")}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.name || ""}
                                  invalid={
                                    validation.touched.name &&
                                    validation.errors.name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.name &&
                                validation.errors.name ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.name}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="label" htmlFor="mobile">
                                  {t("Fields.Mobile")}
                                  <span className="text-danger">*</span>
                                </label>
                                <Input
                                  type="tel"
                                  className="form-control"
                                  id="mobile"
                                  maxLength={10}
                                  minLength={8}
                                  placeholder={t(
                                    "Fields.Your registered Mobile Number"
                                  )}
                                  value={validation.values.mobile || ""}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const { value } = e.target;
                                    const regex =
                                      /^(0*[0-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                                    if (regex.test(value.toString())) {
                                      validation.setValues({
                                        ...validation.values,
                                        mobile: value,
                                      });
                                    } else {
                                      validation.setValues({
                                        ...validation.values,
                                        mobile: "",
                                      });
                                    }
                                  }}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.mobile &&
                                    validation.errors.mobile
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.mobile &&
                                validation.errors.mobile ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.mobile}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">
                                {t("Fields.Email")}
                                {" ("}
                                {t("Common.Optional")}
                                {")"}
                              </label>
                              <Input
                                name="email"
                                className="form-control"
                                placeholder={t("Fields.Enter Email")}
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="col-md-12 mb-3">
                              <label className="label" htmlFor="reason">
                                {t("Fields.Reason")}
                                <span className="text-danger">*</span>
                              </label>
                              <Input
                                type="textarea"
                                name="reason"
                                className="form-control"
                                cols="30"
                                rows="4"
                                placeholder={t("Fields.Specify the Reason")}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.reason || ""}
                                invalid={
                                  validation.touched.reason &&
                                  validation.errors.reason
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.reason &&
                              validation.errors.reason ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.reason}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="col-md-12">
                              <Button type="submit" className="btn btn-success">
                                {t("Common.Submit Request")}
                              </Button>
                              <Link to="/support" className="float-end">
                                <u>{t("Common.Contact Us")}</u>
                              </Link>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                    <div className="col-lg-5 col-md-5 d-flex align-items-stretch">
                      <div className="info-wrap bg-primary w-100 p-md-5 p-4">
                        <h3>
                          <u>{t(`Messages.Information.Delete Your Account`)}</u>
                        </h3>
                        <p className="mb-4" style={{ lineHeight: 1.7 }}>
                          {t("Messages.Information.Account Delete Message 1")}
                          {t("Messages.Information.Account Delete Message 2")}
                        </p>
                        <p>
                          {t(`Messages.Information.Account Delete Message 5`)}
                        </p>
                        <p className="mb-4"></p>
                        <p className="mb-4" style={{ lineHeight: 1.7 }}>
                          <strong>
                            <u>
                              {t(
                                "Messages.Information.Account Delete Message 3"
                              )}
                            </u>
                          </strong>
                          <br />
                          {t("Messages.Information.Account Delete Message 4")}
                          <br />
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default withRouter(AccountDeleteRequestPage);
